import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * usuarios lista filtros
 */

type State = {
  nome?: string,
  login?: string,
  idsGrupoAcesso?: number[],
  idsCentroCusto?: number[],
  email?: string,
  status?: number,
};

type Action = {
  setNome: (nome: string | undefined) => void,
  setLogin: (login: string | undefined) => void,
  setIdsGrupoAcesso: (idsGrupoAcesso: number[] | undefined) => void,
  setIdsCentroCusto: (idsCentroCusto: number[] | undefined) => void,
  setEmail: (email: string | undefined) => void,
  setStatus: (status: number | undefined) => void,
  clearFilters: () => void,
};

/**
 * useFilters
 */

export const useUsuariosListaFilters = create<State & Action>((set) => ({
  nome: undefined,
  login: undefined,
  idsGrupoAcesso: undefined,
  idsCentroCusto: undefined,
  email: undefined,
  status: 0,
  setNome: (nome) => set({ nome }),
  setLogin: (login) => set({ login }),
  setIdsGrupoAcesso: (idsGrupoAcesso) => set({ idsGrupoAcesso }),
  setIdsCentroCusto: (idsCentroCusto) => set({ idsCentroCusto }),
  setEmail: (email) => set({ email }),
  setStatus: (status) => set({ status }),
  clearFilters: () => set({
    nome: undefined,
    login: undefined,
    idsGrupoAcesso: undefined,
    idsCentroCusto: undefined,
    email: undefined,
    status: 0,
  }),
}));


export const initialUsuariosListaFiltersValues: State = {
  nome: '',
  login: '',
  idsGrupoAcesso: [],
  idsCentroCusto: [],
  email: '',
  status: 0,
};

